import { Employee } from "../../Mitarbeiter/types/Types"

export const AbsenceStatus = {
    APPROVED: "Genehmigt",
    IN_REVIEW: "In Prüfung",
    REJECTED: "Abgelehnt",
    CANCELLED: "Storniert",
}

export type AbsenceType = {
    _id: string
    employee: Employee
    type: string
    status: string
    startDate: Date
    endDate: Date
    comment: string
    createdAt: Date
    updatedAt: Date
    conflictingAbsences?: AbsenceType[]
}

export type AbsencePost = {
    employee: string
    type: string
    startDate: Date
    endDate: Date
    comment?: string
}